(function () {
  if (window.__hotspotInit) return;
  window.__hotspotInit = true;

  var MARGIN = 10;

  function resetPopup(popup) {
    popup.style.left        = '';
    popup.style.top         = '';
    popup.style.right       = '';
    popup.style.bottom      = '';
    popup.style.transform   = '';
  }

  function adjustPopup(hotspot) {
    var popup     = hotspot.querySelector('[data-hotspot-popup]');
    var container = hotspot.parentElement;

    if (!popup || !container) return;

    resetPopup(popup);

    requestAnimationFrame(function () {
      var popupRect     = popup.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      var hotspotRect   = hotspot.getBoundingClientRect();

      var popupW = popupRect.width;
      var popupH = popupRect.height;

      // --- Horizontal: clamp popup inside container ---
      // Adjust popup.style.left (in px) rather than transform so the fix
      // works regardless of whether CSS uses translateX(-50%) or translate(0%).
      // Parent .hotspot has only a translate() transform (no scale), so
      // changing left by N px moves the rendered popup by exactly N px.
      var curLeft  = popupRect.left;
      var minLeft  = containerRect.left + MARGIN;
      var maxLeft  = containerRect.right - MARGIN - popupW;
      var wantLeft = Math.max(minLeft, Math.min(maxLeft, curLeft));
      var shiftX   = Math.round(wantLeft - curLeft);

      if (shiftX !== 0) {
        var computedLeft = parseFloat(getComputedStyle(popup).left);
        popup.style.left = (computedLeft + shiftX) + 'px';
      }

      // --- Vertical: prefer below, flip above if overflow, clamp if still out ---
      var overflowBottom = popupRect.bottom - containerRect.bottom;

      if (overflowBottom > 0) {
        var newTop    = -(popupH + MARGIN);
        var newAbsTop = hotspotRect.top + newTop;

        if (newAbsTop < containerRect.top + MARGIN) {
          newTop = containerRect.top + MARGIN - hotspotRect.top;
        }

        popup.style.top = newTop + 'px';
      }
    });
  }

  function closeAll() {
    document.querySelectorAll('[data-hotspot-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      var popup = trigger.closest('[data-hotspot]').querySelector('[data-hotspot-popup]');
      if (popup) resetPopup(popup);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-hotspot-trigger]');

    if (trigger) {
      var isOpen  = trigger.getAttribute('aria-expanded') === 'true';
      var hotspot = trigger.closest('[data-hotspot]');
      closeAll();
      if (!isOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        adjustPopup(hotspot);
      }
      e.stopPropagation();
      return;
    }

    if (!e.target.closest('[data-hotspot]')) {
      closeAll();
    }
  });
})();
